import * as Sentry from '@sentry/react';

const requiredEnv = [
   'REACT_APP_FIREBASE_API_KEY',
   'REACT_APP_FIREBASE_AUTH_DOMAIN',
   'REACT_APP_FIREBASE_PROJECT_ID',
   'REACT_APP_FIREBASE_STORAGE_BUCKET',
   'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
   'REACT_APP_FIREBASE_APP_ID',
   'REACT_APP_API_BASE',
   'REACT_APP_COUCH_DB',
];

export const validateEnv = () => {
   const missing = requiredEnv.filter((key) => !process.env[key]);
   if (missing.length > 0) {
      const message = `Missing required environment variables: ${missing.join(', ')}`;
      // Fail fast so we don't run with a broken configuration.
      console.error(message);
      Sentry.captureException(new Error(message), {
         tags: {
            environment: process.env.NODE_ENV,
            missingVars: missing.join(','),
         },
      });
   }

   if (process.env.NODE_ENV === 'production') {
      if (
         process.env.REACT_APP_API_BASE &&
         !process.env.REACT_APP_API_BASE.startsWith('https://')
      ) {
         Sentry.captureException(new Error('Invalid API base URL in production'), {
            tags: {
               environment: process.env.NODE_ENV,
               apiBase: process.env.REACT_APP_API_BASE,
            },
         });
         console.error('REACT_APP_API_BASE must use HTTPS in production.');
      }
   }
};
